<template>
    <div class="tree">
        <div class="firstTree" v-for="(item,index) in dateSource" :key="item.id">
            <div @dblclick.stop="dbClickNode('',item,index)" @click="checkNode('',item,index)" :class="{'nodeLight':item.id==clickNodeInfo.id}" class="r-xc-yc treeNode firstNode">
                <i :class="[item.display ? 'el-icon-caret-bottom' : 'el-icon-caret-right','node-icon'+item.lvl]" @click.stop="showFirstChild(item)"></i>
                <slot name="header" :data="item" :node="{'data':item,'id':item.id,parendChilds:dateSource,parentId:0,'isCheck':item.id==clickNodeInfo.id}"></slot>
            </div>
            <div class="secordTree" v-for="(item2,index2) in item.children" :key="item2.id">
                <div v-if="item.display" :class="{'nodeLight':item2.id==clickNodeInfo.id}" @click="checkNode(item,item2,index2)" @dblclick.stop="dbClickNode(item,item2,index2)" class="r-xc-yc treeNode secordNode">
                    <i :class="[item2.display ? 'el-icon-caret-bottom' : 'el-icon-caret-right','node-icon'+item2.lvl]" @click.stop="showSecordChild(item,item2)"></i>
                    <slot name="header" :data="item2" :node="{'data':item2,'id':item2.id,parendChilds:item.children,parentId:item.id,'isCheck':item2.id==clickNodeInfo.id}"></slot>
                </div>
                <div class="thirdTree" v-for="(item3,index3) in item2.children" :key="item3.id">
                    <div v-if="item2.display" @click="checkNode(item2,item3,index3)" :class="{'nodeLight':item3.id==clickNodeInfo.id}"  @dblclick.stop="dbClickNode(item2,item3,index3)" class="r-xc-yc treeNode thirdNode">
                        <i :class="[item3.display ? 'el-icon-caret-bottom' : 'el-icon-caret-right','node-icon'+item3.lvl]" @click.stop="showThirdChild(item,item2,item3)"></i>
                        <slot name="header" :data="item3" :node="{'data':item3,'id':item3.id,parendChilds:item2.children,parentId:item2.id,'isCheck':item3.id==clickNodeInfo.id}"></slot>
                    </div>
                    <div class="fourthTree" v-for="(item4,index4) in item3.children" :key="item4.id">
                        <div v-if="item3.display" @click="checkNode(item3,item4,index4)" :class="{'nodeLight':item4.id==clickNodeInfo.id}" @dblclick.stop="dbClickNode(item3,item4,index4)" class="r-xc-yc treeNode fourNode">
                            <i :class="['el-icon-caret-right','node-icon'+item4.lvl]"></i>
                            <slot name="header" :data="item4" :node="{'data':item4,'id':item4.id,parendChilds:item3.children,parentId:item3.id,'isCheck':item4.id==clickNodeInfo.id}"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'flTree',
        props: {
            dateSourcea: {
                type: Array,
                default: () => []
            }
        },
        data(){
            return {
                dateSource:[],  //树结构的数据
                nowLevel: -1,   //当前节点层级
                nowItem: {},    //当前节点信息
                nowIndex: -1,   //当前节点下标
                parentNode: {},     //父节点信息
                clickNodeInfo: {}   //选中节点信息
            }
        },
        computed:{
        },
        mounted(){
            //tree数据请求成功会调用deepCopy这个方法，实现tree的渲染
            // this.dateSource = this.deepCopy(this.dateSourcea);
        },
        methods: {
            resetData(){
                this.dateSource=[];
                this.nowLevel= -1;
                this.nowItem={};
                this.nowIndex=-1;
                this.parentNode={};
                this.clickNodeInfo={};
            },
            updateTreeData(arr,id){
                this.resetData()
                this.dateSource = this.deepCopy(arr,id);
            },
            insertUpNode(){ //向上插入层级，向父节点加入一个默认数据节点
                this.nowItem.isEdit=false
                let nodeItem = {isEdit:true,lvl:this.nowLevel,id:-1};
                this.parentNode.splice(this.nowIndex,0,nodeItem);

                // 设置当前节点为新增节点
                this.nowItem = this.parentNode[this.nowIndex]

                this.clickNodeInfo = this.nowItem   //选中插入的节点为当前节点

                this.$emit("dbclick",nodeItem); //模拟双击节点，自动获取输入框焦点
            },
            insertDownNode(level){  //向下插入层级，插入的层级和当前层级一样则在父节点上追加节点，比当前节点低则在当前节点加入children子节点
                this.nowItem.isEdit=false;
                if(this.nowLevel==level){   //同层级
                    this.parentNode.splice(this.nowIndex+1,0,{isEdit:true,lvl:level,id:-1})
                    this.nowItem = this.parentNode[++this.nowIndex]
                }else{  //子层级
                    if(!this.nowItem.children){
                        this.nowItem.children = [];
                    }
                    this.nowItem.children.push({isEdit:true,lvl:level,id:-1});

                    //新增节点后，重新设置父节点与当前节点
                    // this.parentNode = this.nowItem.children;
                    this.parentNode = this.nowItem;
                    this.nowIndex = this.nowItem.children.length-1
                    this.nowItem = this.nowItem.children[this.nowItem.children.length-1]
                }
                this.clickNodeInfo = this.nowItem   //选中插入的节点为当前节点
                this.$emit("dbclick",this.nowItem); //模拟双击节点，自动获取输入框焦点
                // this.nowItem = {};  //当前节点为空
            },
            updatePartTree(id){
                this.treeDeepForeach(this.dateSource,id)
            },
            getNode(){  //获取当前节点
                return this.nowItem
            },
            remove(res,callBack){   //移除节点
                this.nowItem.isEdit=false;
                console.log(JSON.stringify(this.parentNode),this.nowIndex,res);
                this.parentNode.splice(this.nowIndex, 1);
                if(this.dateSource==undefined||this.dateSource==null||this.dateSource==''){
                    callBack()
                }else if(this.dateSource.length==0){
                    callBack()
                }
            },
            isEmpty(data){
                if(data==null||data==undefined||data==""){
                    return true
                }else{
                    return false
                }
            },
            dbClickNode(pitem,item,index){  //双击节点编辑
                // if(this.nowItem.isEdit){
                //     this.$message.error("请先完成编辑");
                //     return;
                // }
                this.nowItem.isEdit=false
                
                this.parentNode = pitem?pitem.children:this.dateSource;

                this.nowIndex = index;
                if(this.isEmpty(item.children)){
                    item.children = [];
                }
                this.nowLevel=item.lvl;
                this.nowItem = item;
                item.isEdit = true;
                this.$emit("dbclick",item);
            },
            createLevel(item,level){    //创建层级按钮进来的方法，只会在最外层追加一个层级
                this.dateSource.push({isEdit:true,label:"",display:true,lvl:level});
            },
            deepCopy(arr,id){
                if (Array.isArray(arr)) {
                    let copyArr = [];
                    for (let i = 0; i < arr.length; i++) {
                        copyArr[i] = this.deepCopy(arr[i],id);
                    }
                    return copyArr;
                } else if (typeof arr === 'object' && arr !== null) {
                    let copyObj = {};
                    for (let key in arr) {
                        copyObj[key] = this.deepCopy(arr[key],id);
                    }
                    copyObj.display = true;
                    copyObj.isEdit = false;
                    copyObj.label = copyObj.name;
                    if(id&&id==copyObj.paperId){    //当传过来id值说明该次更新是创建试卷，模拟点击tree节点流程
                        this.clickNodeInfo = copyObj;   //恢复之前选中节点
                        // this.checkNode(copyObj);
                        this.$emit('nodeClick',copyObj);    //创建试题后默认出现该试题
                    }
                    return copyObj;
                } else {
                    return arr;
                }
            },
            treeForeach (tree) {   //深度优先遍历
                tree&&tree.forEach(data => {
                    data.display = false;
                    data.children && this.treeForeach(data.children) // 遍历子树
                })
            },
            treeDeepForeach (tree,id) {   //深度优先遍历
                tree&&tree.forEach(data => {
                    if(data.id==-1){
                        data.id = id
                        return;
                    }
                    data.children && this.treeForeach(data.children,id) // 遍历子树
                })
            },
            traverseTree(node) {    //广度优先遍历
                if (node === null) return;  // 当前节点为空，则直接返回
                const queue = [node];  // 使用队列存储待遍历的节点
                while (queue.length > 0) {
                    const current = queue.shift();  // 出队一个节点
                    console.log(current.value);  // 遍历当前节点
                    for (let i = 0; i < current.children.length; i++) {
                    queue.push(current.children[i]);  // 将子节点入队
                    }
                }
            },
            checkNode(pitem,item,index){
                this.sureNode(pitem,item,index)

                this.clickNodeInfo = item;
                if(this.nowItem.isEdit){
                    return;
                }
                this.$emit('nodeClick',item);
            },
            sureNode(pitem,item,index){
                // if(this.nowItem.isEdit){
                //     this.$message.error("请先完成编辑");
                //     return;
                // }
                // this.nowItem.isEdit=false
                
                this.parentNode = pitem?pitem.children:this.dateSource;

                this.nowIndex = index;
                if(this.isEmpty(item.children)){
                    item.children = [];
                }
                this.nowLevel=item.lvl;
                this.nowItem = item;
                // item.isEdit = true;
                // this.$emit("dbclick",item);
            },
            //切换一级列表
            showFirstChild(item){
                let index = this.dateSource.findIndex(data=>{
                    return data == item
                })
                if(this.dateSource[index].display){
                    this.treeForeach(this.dateSource[index].children);
                }
                if(this.$attrs.onlyShowOne == ''){
                    this.dateSource.map(item=>{
                        item.children.map(item2=>{
                            item2.children.map(item3=>{
                                item3.children.map(item4=>{
                                    return item4.display = false;
                                })
                                return item3.display = false;
                            })
                            return item2.display = false;
                        })
                        return item.display = false
                    })
                }
                console.log(item);
                this.dateSource[index].display = !this.dateSource[index].display
                this.$emit('afterToggle',this.dateSource[index])
            },
            //切换二级列表
            showSecordChild(item,item2) {
                //一级下标
                var index = this.dateSource.findIndex(data=>{
                    return data == item
                })
                //二级下标
                var index2 = item.children.findIndex(data=>{
                    return data == item2
                })
                // if(this.$attrs.onlyShowOne == ''){
                //     this.dateSource.map(item=>{
                        // item.children.map(item2=>{
                // console.log(item,item2);
                if(item2.children){
                    item2.children.map(item3=>{
                        // item3.children.map(item4=>{
                        //     return item4.display = false;
                        // })
                        return item3.display = false;
                    })
                }
                
                console.log(item,item2);
                            // item2.children.map(item3=>{
                            //     item3.children.map(item4=>{
                            //         return item4.display = false;
                            //     })
                            //     return item3.display = false;
                            // })
                        //     return item2.display = false;
                        // })
                        // return item.display = false
                //     })
                // }
                
                this.dateSource[index].children[index2].display = !this.dateSource[index].children[index2].display
                this.$emit('afterToggle',this.dateSource[index].children[index2])
            },
            //切换三级列表
            showThirdChild(item,item2,item3) {
                //一级下标
                var index = this.dateSource.findIndex(data=>{
                    return data == item
                })
                //二级下标
                var index2 = item.children.findIndex(data=>{
                    return data == item2
                })
                //三级下标
                var index3 = item2.children.findIndex(data=>{
                    return data == item3
                })
                
                this.dateSource[index].children[index2].children[index3].display = !this.dateSource[index].children[index2].children[index3].display
            }
        },
    }
</script>

<style scoped>
.tree{
    width: 100%;
    padding: 0 15rem 15rem;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    /* width:200px; */
    /* font-size: ; */
}
.secordTree{
    /* padding-left:20rem; */
}
.thirdTree{
    /* padding-left:20rem; */
}
.fourthTree{
    /* padding-left:20rem; */
}
.treeNode{
    padding: 5rem;
    cursor: pointer;
}
.secordNode{
    padding-left:20rem;
}
.thirdNode{
    padding-left:40rem;
}
.fourNode{
    padding-left:60rem;
}
i{
    cursor: pointer;
}
.r-xc-yc{
    display: flex;
    flex-direction: row;
    flex-direction: center;
    align-items: center;
}

.treeNode:hover{
    background: #D5FAE0;
}
.nodeLight{
    background: #D5FAE0;
}
    .node-icon1{
        color:#FA80C6;
    }
    .node-icon2{
        color:#3987EF;
    }
    .node-icon3{
        color:#FCCA00;
    }
    .node-icon4{
        color:#333333;
    }
</style>
